import { connect, MapStateToProps } from 'react-redux';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../types/store';

import { Props } from './StorageCapacityWithUpsell';

export type StateProps = Pick<
  Props,
  'freeCapacity' | 'maxCapacity' | 'coreLevel'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  freeCapacity: state.studio!.freeCapacity,
  maxCapacity: state.studio!.maxCapacity,
  coreLevel: getCoreLevel(state),
});

export default connect(mapStateToProps);
